<template>
    <div class="font-bold flex text-base lg:text-2xl items-center justify-center" :class="{'text-danger': error}">
        <span class="1/3">R$</span>
        <input :disabled="disabled" v-model="priceVModel" v-money="money" :class="{'text-danger': error}" class="ml-2 w-12 lg:w-24 border-none font-bold text-base lg:text-2xl" style="color:#626262" @input="() => $emit('input', priceVModel.replace('.','').replace(',', '.'))"/>
    </div>
</template>

<script>
export default {
    props: {
        price: {
            type: String|Number,
            required: true
        },
        priceGiven: {
            type: String|Number,
            required: false
        },
        error:Boolean,
        disabled: Boolean
    },
    data () {
        return {
            priceVModel: 0.00,
            maxDiscount: 0.00,
            money: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                masked: true
            }
        }
    },

    methods: {

    },
    created() {
        this.priceVModel = parseFloat(this.priceGiven || this.price).toFixed(2).toString();
    },

    watch: {
        price (newVal) {
            this.priceVModel = parseFloat(this.priceGiven || this.price).toFixed(2).toString();
        }
    }
}
</script>

<style scoped>
    input:disabled {
        background: transparent !important;
    }
</style>
